import * as React from "react";
const IconNl = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.5 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 85.5h513v342H0z" />
    <path  d="M0 85.5h513v114H0z" />
    <path  d="M0 312h513v114H0z" />
  </svg>
);
export default IconNl;
